import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_4d81b696 from 'nuxt_plugin_plugin_4d81b696' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_image_ac5fc5c4 from 'nuxt_plugin_image_ac5fc5c4' // Source: ./image.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_7687cc6a from 'nuxt_plugin_cookieuniversalnuxt_7687cc6a' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_826dbfba from 'nuxt_plugin_axios_826dbfba' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_distplugin7bd550d9_dac8756e from 'nuxt_plugin_distplugin7bd550d9_dac8756e' // Source: ./dist.plugin.7bd550d9.mjs (mode: 'all')
import nuxt_plugin_api_984ce652 from 'nuxt_plugin_api_984ce652' // Source: ../core/plugins/api.js (mode: 'all')
import nuxt_plugin_dates_1674fc0b from 'nuxt_plugin_dates_1674fc0b' // Source: ../core/plugins/dates (mode: 'all')
import nuxt_plugin_appContext_033c3b22 from 'nuxt_plugin_appContext_033c3b22' // Source: ../core/plugins/appContext.js (mode: 'all')
import nuxt_plugin_piniaServerInit_39041c1e from 'nuxt_plugin_piniaServerInit_39041c1e' // Source: ../core/plugins/piniaServerInit.js (mode: 'server')
import nuxt_plugin_checkDeviceType_3d086159 from 'nuxt_plugin_checkDeviceType_3d086159' // Source: ../core/plugins/checkDeviceType.js (mode: 'all')
import nuxt_plugin_veevalidate_185b6f70 from 'nuxt_plugin_veevalidate_185b6f70' // Source: ../core/plugins/vee-validate.js (mode: 'client')
import nuxt_plugin_clickOutside_340203e0 from 'nuxt_plugin_clickOutside_340203e0' // Source: ../core/plugins/clickOutside.js (mode: 'client')
import nuxt_plugin_infinityScroll_34aa7970 from 'nuxt_plugin_infinityScroll_34aa7970' // Source: ../core/plugins/infinityScroll.js (mode: 'client')
import nuxt_plugin_geolocation_d523712a from 'nuxt_plugin_geolocation_d523712a' // Source: ../core/plugins/geolocation.js (mode: 'client')
import nuxt_plugin_yaMetrica_9109cef0 from 'nuxt_plugin_yaMetrica_9109cef0' // Source: ../core/plugins/yaMetrica.js (mode: 'client')
import nuxt_plugin_tmrMetrica_dfc15db6 from 'nuxt_plugin_tmrMetrica_dfc15db6' // Source: ../core/plugins/tmrMetrica.js (mode: 'client')
import nuxt_plugin_card2CardPopup_1a83bdc3 from 'nuxt_plugin_card2CardPopup_1a83bdc3' // Source: ../core/plugins/card2CardPopup.js (mode: 'client')
import nuxt_plugin_leads_16e7421d from 'nuxt_plugin_leads_16e7421d' // Source: ../core/plugins/leads (mode: 'client')
import nuxt_plugin_meta_02a2a907 from 'nuxt_plugin_meta_02a2a907' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":(titleChunk) => {
      return titleChunk ?
      `${titleChunk}` :
      'Коммерческий банк «Центр-инвест» | Банковские услуги физическим и юридическим лицам ';
    },"htmlAttrs":{"lang":"ru"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Банковские услуги юридическим и физическим лицам | ПАО коммерческий банк Центр-инвест"},{"hid":"keywords","name":"keywords","content":"Банк для юридических лиц, банк для физических лиц, обслуживание в банке, интернет-банк"},{"name":"format-detection","content":"telephone=no"},{"name":"google-site-verification","content":"r3owMhE5bnuKytJ1j2aFOk1BZWM_NfW-WS1bxggDIKw"},{"name":"yandex-verification","content":"4918f21eb1997c3d"},{"http-equiv":"Cache-Control","content":"no-cache, no-store, must-revalidate"},{"http-equiv":"Pragma","content":"no-cache"},{"http-equiv":"Expires","content":0}],"link":[{"rel":"icon","type":"image\u002Fsvg+xml","href":"\u002Ffavicon.svg"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Fsite-api.centrinvest.ru"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fsite-api.centrinvest.ru"}],"script":[{"src":"\u002Fscripts\u002Fanalytics.js","defer":true},{"src":"https:\u002F\u002Fforms.yandex.ru\u002F_static\u002Fembed.js","async":true},{"src":"\u002Fscripts\u002FsolowayMain.js","defer":true}],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4d81b696 === 'function') {
    await nuxt_plugin_plugin_4d81b696(app.context, inject)
  }

  if (typeof nuxt_plugin_image_ac5fc5c4 === 'function') {
    await nuxt_plugin_image_ac5fc5c4(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_7687cc6a === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_7687cc6a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_826dbfba === 'function') {
    await nuxt_plugin_axios_826dbfba(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin7bd550d9_dac8756e === 'function') {
    await nuxt_plugin_distplugin7bd550d9_dac8756e(app.context, inject)
  }

  if (typeof nuxt_plugin_api_984ce652 === 'function') {
    await nuxt_plugin_api_984ce652(app.context, inject)
  }

  if (typeof nuxt_plugin_dates_1674fc0b === 'function') {
    await nuxt_plugin_dates_1674fc0b(app.context, inject)
  }

  if (typeof nuxt_plugin_appContext_033c3b22 === 'function') {
    await nuxt_plugin_appContext_033c3b22(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_piniaServerInit_39041c1e === 'function') {
    await nuxt_plugin_piniaServerInit_39041c1e(app.context, inject)
  }

  if (typeof nuxt_plugin_checkDeviceType_3d086159 === 'function') {
    await nuxt_plugin_checkDeviceType_3d086159(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidate_185b6f70 === 'function') {
    await nuxt_plugin_veevalidate_185b6f70(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickOutside_340203e0 === 'function') {
    await nuxt_plugin_clickOutside_340203e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_infinityScroll_34aa7970 === 'function') {
    await nuxt_plugin_infinityScroll_34aa7970(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_geolocation_d523712a === 'function') {
    await nuxt_plugin_geolocation_d523712a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yaMetrica_9109cef0 === 'function') {
    await nuxt_plugin_yaMetrica_9109cef0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tmrMetrica_dfc15db6 === 'function') {
    await nuxt_plugin_tmrMetrica_dfc15db6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_card2CardPopup_1a83bdc3 === 'function') {
    await nuxt_plugin_card2CardPopup_1a83bdc3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_leads_16e7421d === 'function') {
    await nuxt_plugin_leads_16e7421d(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_02a2a907 === 'function') {
    await nuxt_plugin_meta_02a2a907(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
